//Componentes generales
import React, { useContext, useReducer } from "react";
import distribucionesReducer from "./distribucionesReducer";
import distribucionesContext from "./distribucionesContext";

//Socket
import { SocketContext } from "../socket/socket";

//Rutas de api
import { getDistribuciones, uploadDistribucion } from "../../api/distribucion"

//Acciones
import {
    ACTUALIZAR_DISTRIBUCIONES,
    ACTUALIZAR_DISTRIBUCIONES_DB,
    CARGANDO_DIST,
    ERROR_DIST,
    LIMPIAR_ERROR
} from "./distribucionesActions";

/*
    State encargado de la gestión de distribuciones.
*/
const DistribucionesState = props => {

    const server = useContext(SocketContext);

    //Valores iniciales
    const initialState = {
        distribuciones: [],
        // Arranca en true: todavía no se hizo la carga inicial, evita mostrar
        // "No hay registros" antes de que llegue la respuesta del servidor.
        cargando: true,
        error: ""
    };

    const [state, dispatch] = useReducer(distribucionesReducer, initialState);

    /*
        Función recuperar las distribuciones.
    */
    const actualizarDistribuciones = async () => {

        try{
            const resp = await getDistribuciones();
            dispatch({
                type: ACTUALIZAR_DISTRIBUCIONES,
                payload: resp.data.data
            })
            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /*
        Función encargada de sobreescribir la tabla de distribuciones con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarDistribucionesDB = async (userID, userName) => {

        try{
            // El endpoint solo confirma que el proceso arrancó en segundo plano;
            // hay que esperar el aviso por socket para saber el resultado real.
            await uploadDistribucion(userID, userName);

            if (!server) {
                throw new Error("No hay conexión en tiempo real disponible. Recargue la página e intente nuevamente.");
            }

            const resultado = await new Promise((resolve) => {
                server.once("actualizarDistribucionesFinalizado", resolve);
            });

            if (resultado.status !== 200) {
                dispatch({
                    type: ERROR_DIST,
                    payload: resultado.message
                });
                return {status: false, msg: resultado.message};
            }

            const resp = await getDistribuciones();
            dispatch({
                type: ACTUALIZAR_DISTRIBUCIONES_DB,
                payload: resp.data.data
            });
        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            const errMsg = error?.response?.data?.errMsg || error.message;
            dispatch({
                type: ERROR_DIST,
                payload: errMsg
            });

            return {status: false, msg: errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_DIST
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <distribucionesContext.Provider
            value={{
                distribuciones: state.distribuciones,
                isCargando: state.cargando,
                error: state.error,
                actualizarDistribuciones,
                actualizarDistribucionesDB,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </distribucionesContext.Provider>
    )

}

export default DistribucionesState;
